import { useFrequentRiderPointsQuery, useFrequentRiderProgramsQuery } from "@graphql/api";
import ConcentricLoader from "@hudson/ui/components/Loader/ConcentricLoader";
import Form from "./Form";

export default function FrequentRiderPoints() {
  const { data: pointsData, loading: pointsLoading, error } = useFrequentRiderPointsQuery();
  const { data: programsData, loading: programsLoading } = useFrequentRiderProgramsQuery();

  if (error) {
    console.error(error);
    return null;
  }

  return pointsLoading || programsLoading ? (
    <ConcentricLoader className="max-w-2xl px-4 mx-auto opacity-60 sm:py-10 sm:px-6 lg:px-8" />
  ) : (
    <Form points={pointsData?.frequentRiderPoints} programs={programsData?.frequentRiderPrograms} />
  );
}
